import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import { IconPresentationProps } from "@insite/mobius/Icon";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// eslint-disable-next-line spire/fenced-imports
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    title = "title",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
    };
}
const mapStateToProps = (state: ApplicationState) => ({
    currentLanguage: state.context.session.language,
});
type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasProduct;

export interface PromoMessageStyles {
    wrapper?: InjectableCss;
    toggleIconProps?: IconPresentationProps;
    specificationsAccordionSection?: AccordionSectionPresentationProps;
    linkCss?: InjectableCss;
    PromobuttonStyles?: InjectableCss;
    whiteButtonStyles?: InjectableCss;
    blackButtonStyles?: InjectableCss;
    blueButtonStyles?: InjectableCss;
}

export const PDPpromoMessageStyles: PromoMessageStyles = {
    whiteButtonStyles: {
        css: css`
            width: 100%;
            padding: 0 18px;
            background: #ffffff !important;
            border: 1px solid rgb(204, 204, 204) !important;
            span[class^="TypographyStyle"] {
                font-size: 12px;
                font-weight: 600;
                letter-spacing: 2px;
                line-height: 20px;
                text-align: center;
                color: #000000;
                text-transform: uppercase;
            } 
            &:hover{
                border: 1px solid rgb(1, 11, 19) !important;
                span[class^="TypographyStyle"] {
                    color: rgb(0, 107, 192); 
                }
            }
      `,
    },
    blackButtonStyles: {
        css: css`
            width: 100%;
            padding: 0 18px;
            background: #313639 !important;
            border: 1px solid #313639  !important;
            span[class^="TypographyStyle"] {
                font-size: 12px;
                font-weight: 600;
                letter-spacing: 2px;
                line-height: 20px;
                text-align: center;
                color: #ffffff;
                text-transform: uppercase;
            } 
            &:hover{
                border: 1px solid #010B13 !important;
                background: #010B13 !important;
                span[class^="TypographyStyle"] {
                    color: #ffffff;
                }
            }
      `,
    },
    blueButtonStyles: {
        css: css`
            width: 100%;
            padding: 0 18px;
            background: #91ADCE !important;
            border: 1px solid #91ADCE  !important;
            span[class^="TypographyStyle"] {
                font-size: 12px;
                font-weight: 600;
                letter-spacing: 2px;
                line-height: 20px;
                text-align: center;
                color: #ffffff;
                text-transform: uppercase;
            } 
            &:hover{
                border: 1px solid #688EB9 !important;
                background: #688EB9 !important;
                span[class^="TypographyStyle"] {
                    color: #ffffff;
                }
            }
      `,
    },
};

const styles = PDPpromoMessageStyles;
const onClick = (url: string, openInNewWindow: string) => {
    if (openInNewWindow === "true") {
        window.open(window.location.origin + url);
    } else {
        window.location.href = window.location.origin + url;
    }
};
const PromoMessage: React.FC<Props> = ({ product, currentLanguage }) => {
    // if (!product.properties.promoPageLink) {
    //     return null;
    // }
    // eslint-disable-next-line no-console
    // console.log(window.location.hostname);
    // eslint-disable-next-line no-debugger

    return (
        <StyledWrapper
            className="promoMessage"
            css={css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                            margin-top: 10px;
                            margin-bottom: 10px;
                        `,
                        css`
                            width: 100%;
                            margin-top: 10px;
                            margin-bottom: 10px;
                        `,
                        css`
                            width: auto;
                            margin-top: 10px;
                            margin-bottom: 10px;
                        `,
                        css`
                            width: auto;
                            display: inline-block;
                            margin-right: 9px;
                            margin-top: 15px;
                            margin-bottom: 15px;

                            vertical-align: middle;
                        `,
                        css`
                            width: auto;
                            display: inline-block;
                            margin-right: 9px;
                            margin-top: 15px;
                            margin-bottom: 15px;
                            vertical-align: middle;
                        `,
                    ])}
            `}
        >
            {product.properties.promoMessageEN && currentLanguage?.languageCode.toLowerCase() === "en" && (
                <Button
                    {...(product.properties.promoColor === "White Background Button") && ({ ...styles.whiteButtonStyles })}
                    {...(product.properties.promoColor === "Black Background Button") && ({ ...styles.blackButtonStyles })}
                    {...(product.properties.promoColor === "Blue Background Button") && ({ ...styles.blueButtonStyles })}
                    onClick={() => onClick(product.properties.promoPageLinkEN, product.properties.promoMessageNewtab)}
                >
                    {product.properties.promoMessageEN}
                </Button>
            )}
            {product.properties.promoMessageES && currentLanguage?.languageCode.toLowerCase() === "es" && (
                <Button
                    {...(product.properties.promoColor === "White Background Button") && ({ ...styles.whiteButtonStyles })}
                    {...(product.properties.promoColor === "Black Background Button") && ({ ...styles.blackButtonStyles })}
                    {...(product.properties.promoColor === "Blue Background Button") && ({ ...styles.blueButtonStyles })}
                    onClick={() => onClick(product.properties.promoPageLinkES, product.properties.promoMessageNewtab)}
                >
                    {product.properties.promoMessageES}
                </Button>
            )}
            {product.properties.promoMessageFR && currentLanguage?.languageCode.toLowerCase() === "fr" && (
                <Button
                    {...(product.properties.promoColor === "White Background Button") && ({ ...styles.whiteButtonStyles })}
                    {...(product.properties.promoColor === "Black Background Button") && ({ ...styles.blackButtonStyles })}
                    {...(product.properties.promoColor === "Blue Background Button") && ({ ...styles.blueButtonStyles })}
                    onClick={() => onClick(product.properties.promoPageLinkFR, product.properties.promoMessageNewtab)}
                >
                    {product.properties.promoMessageFR}
                </Button>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(PromoMessage)),
    definition: {
        displayName: "Promo Message",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "Promo Message",
                fieldType: "Translatable",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
